import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './DesktopTypeContainer';
import { DesktopTypeItem } from './DesktopTypeItem';
import { DesktopTypeItemCount } from './DesktopTypeItemCount';
import { searchConstants } from '../../search-utils/searchConstants';
import { StateType } from '../../../state/state.types';
import styles from './desktop_type.module.scss';

type Props = {
  onClick: (selected: keyof StateType['results']['counts']) => void;
} & PropsFromRedux;

export class RawDesktopType extends React.Component<Props> {
  typeOfResultChanged = (
    selectedType: keyof StateType['results']['counts'],
  ) => (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent> & {
      ctrlKey: boolean;
      metaKey: boolean;
    },
  ) => {
    const { onClick, onTypeChanged, hasQuery } = this.props;
    if (!event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      onTypeChanged(selectedType, hasQuery);
      onClick(selectedType);
    }
  };

  render() {
    const { types } = searchConstants;
    return (
      <div className={styles.menu}>
        {types.map(({ key, labelId }) => (
          <React.Fragment key={key}>
            <DesktopTypeItem
              type={key}
              onTypeChanged={this.typeOfResultChanged(key)}
            >
              <FormattedMessage id={labelId} />
              <DesktopTypeItemCount type={key} />
            </DesktopTypeItem>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export const DesktopType = Connect(RawDesktopType);
